import axios from "axios";

const axiosClient = axios.create({
  baseURL: "https://staging-third-party-apis.nabil5332.workers.dev/api/v1",
  headers: { "Content-Type": "application/json" },
});

axiosClient.interceptors.request.use((config) => {


  if (config.url?.startsWith("/manage")) {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("⚠️ Token non trouvé dans localStorage pour /manage");
    }
  } else {
    const apiKey = localStorage.getItem("apiKey");

    if (!apiKey) {
      console.error("❌ API key non trouvée dans localStorage");
    } else {
      config.headers.Authorization = `Bearer ${apiKey}`;
    }
  }

  return config;
}, (error) => {
  console.error("❌ Erreur dans l'intercepteur request :", error);
  return Promise.reject(error);
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("❌ Erreur réponse axios :", error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default axiosClient;
